export class RestoreImage201ResponseMpaPolicies {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<MPAPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreImage201ResponseMpaPolicies.attributeTypeMap;
    }
    constructor() {
    }
}
